<template>
  <b-card
    v-bind="cardAttrs"
    no-body
    v-on="$listeners"
  >
    <div class="card-header">
      <!-- Title & SubTitle -->
      <div>
        <b-card-title>{{ $attrs.title }}</b-card-title>
        <b-card-sub-title v-if="$attrs['sub-title']">
          {{ $attrs['sub-title'] }}
        </b-card-sub-title>
      </div>

      <i
        class="code-toggler feather icon-code cursor-pointer"
        :aria-expanded="!codeVisible ? 'true' : 'false'"
        :aria-controls="parentID"
        @click="codeVisible = !codeVisible"
      />
    </div>

    <template v-if="$attrs['no-body'] !== undefined">
      <slot />

      <!-- Code Content -->
      <b-collapse
        :id="parentID"
        v-model="codeVisible"
        class="card-code"
        :visible="codeVisible"
      >
        <b-card-body>
          <prism :language="codeLanguage">
            <slot name="code" />
          </prism>
        </b-card-body>

      </b-collapse>
    </template>

    <b-card-body v-else>
      <!-- Card Content -->
      <slot />

      <!-- Code Content -->
      <b-collapse
        :id="parentID"
        v-model="codeVisible"
        class="card-code"
        :visible="codeVisible">
        <div class="p-1"></div>

        <div class="vx-row mb-1" v-if="shortUrl">
          <div class="vx-col w-full">
            <label>URL encurtada:</label>
            <span class="align-left w-full flex cursor-pointer pb-2 gap-2"
              v-clipboard:copy="shortUrl"
              v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
              v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
              v-tooltip.top="{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}"
              >
              <feather-icon
                  icon="LinkIcon"
                  svgClasses="h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"/>
              {{shortUrl}}
            </span>
          </div>
        </div>

        <div class="vx-row mb-1">
          <div class="vx-col w-full">
            <prism :language="codeLanguage" ref="code">
              <slot name="code" />
            </prism>
            <b-button
              v-if="showCopy"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              class="float-right mt-1"
              @click="copy">
              <feather-icon
                icon="CopyIcon"
                class="mr-50"/>
              <span class="align-middle">Copiar</span>
            </b-button>
          </div>
        </div>
        <div class="vx-row mb-1" v-if="codeEmbed">
          <div class="vx-col w-full">
            <prism :language="html" ref="embed">{{codeIframe}}</prism>
            <b-button
              v-if="showCopy"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              class="float-right mt-1"
              @click="copyEmbed">
              <feather-icon
                icon="CopyIcon"
                class="mr-50"/>
              <span class="align-middle">Copiar</span>
            </b-button>
          </div>
        </div>
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle, BCardBody, BCollapse, BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    BButton,
    Prism,
    Ripple
  },
  inheritAttrs: false,
  props: {
    codeLanguage: {
      default: 'markup',
      type: String,
    },
    codeVisible: {
      default: false,
      type: Boolean,
    },
    showCopy: {
      default: false,
      type: Boolean,
    },
    codeEmbed: {
      default: false,
      type: Boolean,
    },
    shortUrl: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      parentID: '',
    }
  },
  computed: {
    cardAttrs() {
      const cardAttrs = JSON.parse(JSON.stringify(this.$attrs))
      delete cardAttrs.title
      delete cardAttrs['sub-title']
      return cardAttrs
    },
    codeIframe() {
      return  "<iframe src='"+this.$slots.code[0].text.trim()+"' frameborder='0'></iframe>"
    },
  },
  methods: {
    copy() {
      const code = this.$refs.code
      this.$copyText(code.innerText.trim()).then((e) =>  {
        this.notifySuccess(this.$vs, 'Cópia realizada com sucesso.')
      }, function (e) {
        this.notifyError(this.$vs, 'Não foi possível realizar a cópia.')
      })
    },
    copyEmbed() {
      const code = this.$refs.embed
      this.$copyText(code.innerText.trim()).then((e) =>  {
        this.notifySuccess(this.$vs, 'Cópia realizada com sucesso.')
      }, function (e) {
        this.notifyError(this.$vs, 'Não foi possível realizar a cópia.')
      })
    }
  },
  created() {
    this.parentID = String(Math.floor(Math.random() * 10) + 1)
  },
  mounted(){

    //console.log(this.$slots.code[0].text)
  }
}
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';

.card-code {
  pre[class*='language-'] {
    margin: 0;
    max-height: 350px;
    border-radius: 0.5rem;
  }

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: #2d2d2d;
      border-radius: 100%;

      .dark-layout & {
        background-color: $theme-dark-body-bg !important;
      }
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      border-radius: 0.5rem;
      background: rgba(241,241,241,.4);
    }

    /* Handle on hover */
    // ::-webkit-scrollbar-thumb:hover {
    // }

    ::-webkit-scrollbar-corner {
      display: none;
    }
}

.code-toggler {
  border-bottom: 1px solid transparent;

  &[aria-expanded='false'] {
    border-bottom-color: $primary;
  }
}

// HTML
.card {
  .card-header .heading-elements {
    position: static;
    background: red;
  }
}
</style>
